<script>
    import { mapActions, mapState } from "vuex";
    import { sendAnalytics } from "@/core/SendAnalytics";
    import BaseButton from "@main/packages/BaseButton";

    export default {
        name: "ProductControls",
        components: { BaseButton },
        props: {
            offerId: Number,
            product: Object,
            inCart: Boolean,
            price: Number,
            isPreOrder: Boolean,
            isIconType: Boolean,
            variantPreOrder: {
                type: String,
                default: "v1",
            },
            variantBuy: {
                type: String,
                default: "v1",
            },
            variantOneClick: {
                type: String,
                default: "v2",
            },
            size: {
                type: String,
                default: "lg",
            },
            isForHeader: Boolean,
        },
        data() {
            return {
                isLoadingBuy: false,
            };
        },
        computed: {
            ...mapState("Root", ["city"]),
            stateBuyButton() {
                const buy = {
                    icon: "cart",
                    text: "В корзину",
                };
                const bought = {
                    icon: "check",
                    text: "В корзине",
                };
                return this.inCart ? bought : buy;
            },
            iconForButton() {
                return this.isIconType ? this.stateBuyButton.icon : "";
            },
        },
        methods: {
            ...mapActions("Root", ["addProductInCart"]),
            buy() {
                if (this.inCart) {
                    return this.$router.push({ name: "Order" });
                }

                this.isLoadingBuy = true;
                this.addProductInCart({
                    quantity: 1,
                    productId: this.offerId,
                }).then(() => {
                    this.isLoadingBuy = false;

                    sendAnalytics.send(sendAnalytics.events.addToCart, {
                        name: this.product.name,
                        offerId: this.offerId,
                        price: this.price,
                    });
                });
            },
            oneClickBuy() {
                this.$popup.show("modal-one-click", {
                    offerId: this.offerId,
                    productName: this.product.name,
                    productPrice: this.price,
                    productSection: this.product.mainCategory?.name,
                    city: this.city,
                });
            },
            showPreOrder() {
                this.$popup.show("modal-pre-order", { offerId: this.offerId });
            },
        },
    };
</script>

<template>
    <div class="product-controls">
        <base-button
            v-if="isPreOrder"
            class="product-controls__btn product-controls__btn--preorder"
            :class="{ 'product-controls__btn--not-compared': !product.canCompared }"
            :variant="variantPreOrder"
            :size="size"
            @click="showPreOrder"
        >
            Узнать о поступлении
        </base-button>

        <template v-else>
            <base-button
                class="product-controls__btn product-controls__btn--buy"
                :size="size"
                :class="{ 'product-controls__btn--not-compared': !product.canCompared }"
                :variant="variantBuy"
                :is-loading="isLoadingBuy"
                :is-selected="inCart"
                :icon="iconForButton"
                @click="buy"
            >
                {{ stateBuyButton.text }}
            </base-button>

            <base-button
                v-if="!isForHeader"
                class="product-controls__btn product-controls__btn--one-click"
                :class="{ 'product-controls__btn--full': !product.canCompared }"
                :variant="variantOneClick"
                :size="size"
                @click="oneClickBuy"
            >
                Купить в 1 клик
            </base-button>
        </template>

        <slot v-if="product.canCompared" name="buttonCompare"></slot>
    </div>
</template>

<style lang="scss">
    .product-controls {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .product-controls__btn--preorder {
        &.base-button {
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>
